import type { TruckbookApiResponse } from 'repositories/axiosClient'

export const DELIVERY_WORK_CATEGORY = {
  GENERAL: 'GENERAL',
  SPECIALIZED: 'SPECIALIZED',
} as const

export type DeliveryWorkCategory =
  (typeof DELIVERY_WORK_CATEGORY)[keyof typeof DELIVERY_WORK_CATEGORY]

// 付帯作業マスタ（テナント設定）。BE は is_visible=true のみを
// category（GENERAL → SPECIALIZED）+ display_order 昇順で返す
export type DeliveryWorkTypeSetting = {
  id: number
  name: string
  category: DeliveryWorkCategory
  displayOrder: number
}

export type GetDeliveryWorkTypeSettingsResponse = TruckbookApiResponse<{
  workTypeSettings: DeliveryWorkTypeSetting[]
}>
